module.exports = __webpack_public_path__ + "static/media/chiapas_flordechiapas_trigofuerte.e8d1411e.png";